<template>
  <div>
    <div class="loader" v-show="!loaded"></div>
    <div class="panel panel-default">
      <div class="panel-heading">Часы доставки</div>

      <div class="panel-body">
        <form>
          <div class="form-group row col-md-4 mb-3">
            <label for="deliveryDate">Выбирите дату</label>
            <input type="date" class="form-control" id="deliveryDate" placeholder="Дата доставки" v-model="deliveryDate" @change="refreshDeliveryHours()">
          </div>

          <div style="clear:both;"></div>

          <div class="form-group row col-md-4 mb-3">
            <div class="form-check" v-for="(item, key) in deliveryHours">
              <input class="form-check-input" type="checkbox" value="" :id="'delivery-hour-'+item"
                     :checked="!disabledHours || disabledHours.indexOf(parseInt(key)) === -1"
                     :value="key"
                      @change="disableHour(key, $event.target.checked)">
              <label class="form-check-label" :for="'delivery-hour-'+item">
                {{item}}
              </label>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {api} from '../http'
var config = require('../config')

export default {
  mounted () {
  },
  data () {
    return {
      url: config.appUrl,
      loaded: false,
      data: [],
      deliveryHours: {
        9: 'С 09:00 до 11:00',
        // 10: 'С 10:00 до 12:00',
        11: 'С 11:00 до 13:00',
        // 12: 'С 12:00 до 14:00',
        13: 'С 13:00 до 15:00',
        // 14: 'С 14:00 до 16:00',
        15: 'С 15:00 до 17:00',
        // 16: 'С 16:00 до 18:00',
        17: 'С 17:00 до 19:00',
        //
        19: 'С 19:00 до 21:00'
      },
      disabledHours: [],
      deliveryDate: (new Date()).toJSON().slice(0, 10)
    }
  },
  beforeCreate () {
    this.loaded = false
    var formData = new FormData()
    formData.append('delivery_date', (new Date()).toJSON().slice(0, 10))
    api.post('settings/fetchDeliveryHours', formData).then(response => {
      this.loaded = true
      this.disabledHours = response.data
    })
  },
  methods: {
    refreshDeliveryHours () {
      var formData = new FormData()
      formData.append('delivery_date', this.deliveryDate)
      this.loaded = false
      api.post('settings/fetchDeliveryHours', formData).then(response => {
        this.loaded = true
        this.disabledHours = response.data
      })
    },
    disableHour (val, checked) {
      this.loaded = false
      var formData = new FormData()
      formData.append('delivery_date', this.deliveryDate)
      formData.append('delivery_hour', val)
      formData.append('delete', checked ? 1 : 0)
      api.post('settings/storeDeliveryHour', formData).then(response => {
        this.loaded = true
        this.disabledHours = response.data
      })
    }
  }
}
</script>

<style>
.loader {
  background-color: rgba(255, 255, 128, .5);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminSettings/AdminSettingsDeliveryTime.vue